export const TOASTR_SHOW = 'fastcover.TOASTR_SHOW';
export const TOASTR_HIDE_ALL = 'fastcover.TOASTR_HIDE_ALL';



// WEBPACK FOOTER //
// ./app/containers/Toastr/constants.js